import React from "react";
import "./Checkbox.css";

const Checkbox = ({ label, onChange, name, error, checked, disabled, ...props }) => {

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.checked, e);
    }
  };

  return (
    <div className={`checkbox-wrapper${error ? ' checkbox-wrapper--error' : ''}`}>
      <label className={`checkbox-container${disabled ? ' checkbox-container--disabled' : ''}`}>
        <input
          type="checkbox"
          name={name}
          checked={checked}
          disabled={disabled}
          {...props}
          onChange={handleChange}
        />
        <span className="checkbox-custom" />
        {label && <span className="checkbox-label">{label}</span>}
      </label>
      {error && <div className="checkbox-error">{error}</div>}
    </div>
  );
};

export default Checkbox;
